import _ from 'lodash'
import React, {Component} from 'react'
import {bool, string, arrayOf} from 'prop-types'
import glamorous from 'glamorous'

import {isBrowser, isInViewport} from '../utils'
import {colors, hexToRgba} from '../css/themes'

const VideoWrapper = glamorous.span({})

export default class VideoComponent extends Component {
  static propTypes = {
    sources: arrayOf(string).isRequired,
    loop: bool,
    autoplay: bool,
    controls: bool,
  }

  static defaultProps = {
    loop: true,
    autoplay: true,
    controls: false,
  }

  _videoRef = null
  _playPromise = null

  _handleScroll = _.debounce(() => {
    if (isInViewport(this._videoRef)) {
      this._playPromise = this._videoRef.play()
    } else {
      if (!this._playPromise) return
      this._playPromise.then(() => {
        this._videoRef.pause()
        this._playPromise = null
      })
    }
  }, 100)

  componentDidMount() {
    if (!this._videoRef) return
    if (!isBrowser()) return
    window.addEventListener('scroll', this._handleScroll)
  }

  componentWillUnmount() {
    if (!isBrowser()) return
    window.removeEventListener('scroll', this._handleScroll)
  }

  render() {
    const data = _.map(this.props.sources, src => {
      const type = _.last(src.split('.'))
      return {src, type}
    })

    return (
      <VideoWrapper>
        <glamorous.Video
          innerRef={el => (this._videoRef = el)}
          loop={this.props.loop}
          playsInline={this.props.autoplay}
          controls={this.props.controls}
          css={{
            height: 'auto',
            width: '100%',
            backgroundColor: hexToRgba(colors.orange, 0.3),
          }}
        >
          {_.map(data, ({src, type}) => {
            return <source key={src} src={src} type={`video/${type}`} />
          })}
        </glamorous.Video>
      </VideoWrapper>
    )
  }
}
